var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hp-10 flex-column fs-3 jc-center ai-center" },
    [
      _c("i", { staticClass: "icon-email-statut-valid success-50" }),
      _vm._v(" "),
      _c("p", { staticClass: "bold mb-5 fs-4" }, [
        _vm._v(_vm._s(_vm.confirmationLabel))
      ]),
      _vm._v(" "),
      _vm.isMultiple
        ? _c(
            "router-link",
            {
              staticClass:
                "semibold mb-5 hover-primary-50-bkg hover-white primary-50-bkg-hover white-bkg br b-1-primary px-3 py-2",
              attrs: { to: { name: "supplier" } }
            },
            [_vm._v(_vm._s(_vm.btnLabel))]
          )
        : _c(
            "a",
            {
              staticClass:
                "semibold mb-5 hover-primary-50-bkg hover-white primary-50-bkg-hover white-bkg br b-1-primary px-3 py-2",
              attrs: {
                href: "/?_f=purchases_purInvoiceOverview&id=" + _vm.linkedid
              }
            },
            [_vm._v(_vm._s(_vm.btnLabel))]
          ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "semibold",
          attrs: { href: "/ocr/list/" + _vm.linkedtype }
        },
        [_vm._v(_vm._s(_vm.$l10n.__("Retourner sur l’import de facture")))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }